/* VOLT scroll reveal — tiny, dependency-free progressive enhancement.
   Elements opt in with [data-volt-reveal]; grids opt in their children with
   [data-volt-reveal-group] (a small stagger is applied per child).
   No-ops entirely under prefers-reduced-motion or without IntersectionObserver:
   content is visible by default and only hidden once this script confirms
   motion is allowed (html.volt-reveal-ready). */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var targets = [];

  document.querySelectorAll('[data-volt-reveal-group]').forEach(function (group) {
    Array.prototype.forEach.call(group.children, function (child, i) {
      child.setAttribute('data-volt-reveal', '');
      child.style.setProperty('--volt-reveal-delay', Math.min(i, 5) * 70 + 'ms');
    });
  });

  document.querySelectorAll('[data-volt-reveal]').forEach(function (el) {
    targets.push(el);
  });
  if (!targets.length) return;

  document.documentElement.classList.add('volt-reveal-ready');

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('volt-revealed');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  targets.forEach(function (el) {
    // Anything already in the viewport reveals immediately (no pop-in on load).
    var rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight && rect.bottom > 0) {
      el.classList.add('volt-revealed');
      return;
    }
    observer.observe(el);
  });
})();
